import React, { useState, useRef } from "react";

import { trackPromise } from "react-promise-tracker";

import { Modal, message } from "antd";

import { gerenciarLink } from "../../services/http/linkCompartilhado";

import IconeArquivos from "../IconeArquivos";

import infoPastaSvg from "../../assets/icons/infoPasta.svg";

import "./styles.scss";
import { Bolt, CloseOutlined } from "@mui/icons-material";
import anexar from "../../assets/icons/iconLink.svg";
import lang from "../../assets/idioma/idiomas";
const ModalGerarLinkUnico = ({ linkGerado, closeModal, openModal }) => {
  const [dataValidade, setDataValidade] = useState(lang.Indefinida);
  const [senha, setSenha] = useState(lang.Indefinida);
  const [modalAlterar, setModalAlterar] = useState(false);
  const [tipoAlteracao, setTipoAlteracao] = useState(null);

  const IncluirDataSenhaLinkUnico = () => {
    if (tipoAlteracao == "d") {
      if (dataValidade == lang.Indefinida || !dataValidade) {
        message.warning(lang.Preencha_o_campo_da_data_de_validade);
        return;
      } else {
        message.success(lang.Data_de_validade_atualizada_com_sucesso);
      }
    }

    if (tipoAlteracao == "s") {
      if (senha == lang.Indefinida || !senha) {
        message.warning(lang.Preencha_o_campo_de_senha);
        return;
      } else {
        message.success(lang.Senha_atualizada_com_sucesso);
      }
    }

    linkGerado.forEach((link) => {
      let dataConvertida = `${dataValidade.split("/")[2]}-${
        dataValidade.split("/")[1]
      }-${(parseInt(dataValidade.split("/")[0]) + 1)
        .toString()
        .padStart(2, "0")}`;

      let data = {
        idLinkCompartilhado: link.idLinkGerado,
        dataValidade:
          dataValidade == lang.Indefinida || !dataValidade
            ? null
            : dataConvertida,
        senhaAcesso: senha == lang.Indefinida || !senha ? null : senha,
      };

      trackPromise(
        gerenciarLink(data)
          .then((res) => {
            if (!res.fail) {
              closeModalAlterar();
            }
          })
          .catch((error) => {
            console.error(error);
          })
      );
    });
  };

  const copiarTexto = (id) => {
    let inputId = `#input${id}`;
    let input = document.querySelector(inputId);
    input.select();
    document.execCommand("copy");
    message.success(lang.Link_copiado_com_sucesso);
  };

  const handleChangeDate = (e) => {
    setDataValidade(new Date(e.target.value).toLocaleDateString());
  };

  const handleAlterarData = () => {
    closeModalAlterar();
    setTipoAlteracao("d");
    showModalAlterar();
  };

  const handleAlterarSenha = () => {
    closeModalAlterar();
    setTipoAlteracao("s");
    showModalAlterar();
  };

  const showModalAlterar = () => {
    setModalAlterar(true);
  };
  const closeModalAlterar = () => {
    setModalAlterar(false);
  };

  const mostrarIconePastaArquivo = (item) => {
    if (item.tipo == 0) {
      return <img src={infoPastaSvg} />;
    } else {
      if (item.urlPreview) {
        return <img src={item.urlPreview} />;
      } else {
        return (
          <IconeArquivos
            tamanho={"P"}
            tipo={String(item.nomeDocumento).split(".")[1]}
          />
        );
      }
    }
  };

  return (
    <div>
      <Modal
        title={<span className="modal-title-obterLink">{lang.Obter_link}</span>}
        visible={openModal}
        className="modal-obterLinkNovo"
        closable={false}
        destroyOnClose={true}
        footer={[]}
      >
        <CloseOutlined onClick={closeModal} className="custom-close-icon" />
        <div>
          <div className="container-alterar-data-senha mt-2">
            <div className="container-data-senha">
              <span className="info-senha-data">
                {lang.Data_de_validade}:{" "}
                <span>
                  {linkGerado[0].dataValidade && dataValidade == lang.Indefinida
                    ? linkGerado[0].dataValidade
                    : dataValidade == lang.Indefinida
                    ? lang.Indefinida
                    : `${(parseInt(dataValidade.split("/")[0]) + 1)
                        .toString()
                        .padStart(2, "0")}/${dataValidade.split("/")[1]}/${
                        dataValidade.split("/")[2]
                      }`}
                </span>
              </span>
              <span className="info-senha">
                {lang.Senha_de_acesso}:{" "}
                <span>
                  {linkGerado[0].senha || senha != lang.Indefinida
                    ? "******"
                    : lang.Indefinida}
                </span>
              </span>
            </div>
            <div className="container-button-senha-data">
              <button onClick={handleAlterarData}>
                {lang.Definir_data_de_validade}
              </button>
              <button onClick={handleAlterarSenha}>
                {lang.Definir_uma_senha}
              </button>
            </div>
          </div>
          <div className="container-link-gerado">
            {linkGerado.map((item, index) => {
              const nomeDocumento =
                item.nomeDocumento.length > 20
                  ? item.nomeDocumento.slice(0, 17) + "..."
                  : item.nomeDocumento;

              return (
                <div className="container-info-link" key={index}>
                  <div className="container-info-item-original">
                    {mostrarIconePastaArquivo(item)}
                    <span className="nome-item" title={item.nomeDocumento}>
                      {nomeDocumento}
                    </span>
                    <span className="tamanho-item">
                      {item.tamanho > 0 ? item.tamanho : ""}
                    </span>
                    <span
                      style={{
                        color: "#828282",
                        fontWeight: "normal",
                        margin: "5px 20px 0 20px",
                      }}
                    >
                      {lang.Pastas + " :" + item.tamanhoPastas}
                    </span>

                    <span
                      style={{
                        color: "#828282",
                        fontWeight: "normal",
                        margin: "5px 20px 0 20px",
                      }}
                    >
                      {lang.Tamanho + " :" + item.tamanhoTotalPastas}
                    </span>
                  </div>
                  <div className="container-copiar-link">
                    <img className="anexar" src={anexar} alt="anexar" />
                    <input
                      className="w-100"
                      id={`input${index}`}
                      value={item.linkGerado}
                      readOnly
                    />

                    <button
                      className="button-copiar-obter "
                      onClick={() => copiarTexto(index)}
                    >
                      {lang.Copiar}
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </Modal>

      <Modal
        visible={modalAlterar}
        className="modal-definir-senha-data"
        closable={false}
        destroyOnClose={true}
        footer={false}
      >
        <CloseOutlined
          onClick={closeModalAlterar}
          className="custom-close-icon"
        />
        <div className="container-input-senha-data">
          {tipoAlteracao == "d" ? (
            <div>
              {" "}
              <labe>Data de validade</labe>{" "}
              <input
                className="input-data mt-3"
                type="date"
                onChange={(e) => handleChangeDate(e)}
              />{" "}
            </div>
          ) : (
            <div>
              {" "}
              <labe>Senha</labe>{" "}
              <input
                className="input-senha mt-3"
                type="password"
                onChange={(e) => setSenha(e.target.value)}
              />{" "}
            </div>
          )}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
            }}
          >
            <button
              className="btn-salvar-senha-data"
              onClick={IncluirDataSenhaLinkUnico}
            >
              Salvar
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ModalGerarLinkUnico;
